import * as React from 'react';

import { BannerViewType, PcodeRenderData } from '../../typings/pcode';

export interface VideoCanvasIFrameProps {
    previewData: PcodeRenderData;
    videoUrl?: string;
    height?: number;
    width?: number;
    type: BannerViewType;
}

export enum CanvasCreativePreviewIFrameMessage {
    ready = 'ready'
}

export class CanvasCreativePreviewIFrame extends React.PureComponent<
    VideoCanvasIFrameProps
> {
    private iframeRef: HTMLIFrameElement | null;

    componentWillMount() {
        window.addEventListener('message', this.onMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage);
    }

    render() {
        const {
            videoUrl,
            width,
            height = 480,
            previewData: { isSquareFormat }
        } = this.props;
        const defaultWidth = isSquareFormat ? 480 : 800;

        return (
            <iframe
                ref={this.setIframeHref}
                frameBorder="0"
                src={videoUrl}
                height={height}
                width={width || defaultWidth}
                allow={'autoplay'}
            />
        );
    }

    private setIframeHref = (ref: HTMLIFrameElement) => {
        this.iframeRef = ref;
    };

    private onMessage = (ev: MessageEvent) => {
        const message = ev.data.type;
        const {
            previewData: { ads },
            type
        } = this.props;

        if (!this.iframeRef || this.iframeRef.contentWindow !== ev.source) {
            return;
        }

        switch (message) {
            case CanvasCreativePreviewIFrameMessage.ready:
                (ev.source as Window).postMessage({ type, data: ads[0] }, '*');
                (ev.source as Window).postMessage(
                    { type: 'preview-start' },
                    '*'
                );
                break;
            default:
                break;
        }
    };
}
